// frontend/src/components/houses/TablaCasas.jsx
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { casasApi } from '../../services/api';
import ModalPago from './ModalPago';

const API = process.env.REACT_APP_API_URL || 'https://api.lamilara.com/api';

function formatMoneda(val) {
  const n = parseFloat(val) || 0;
  return `$${n.toFixed(2)}`;
}

function formatFecha(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-VE',
    { day:'2-digit', month:'short', year:'numeric' });
}

const badgeEstatus = (estatus) => ({
  display:'inline-block', padding:'3px 10px', borderRadius:20,
  fontSize:11, fontWeight:600,
  background: estatus === 'SOLVENTE' ? '#dcfce7' : '#fee2e2',
  color:       estatus === 'SOLVENTE' ? '#15803d' : '#dc2626',
});

// ── Modal de Detalle ──────────────────────────────────────
function ModalDetalle({ casaId, onClose }) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/casas/${casaId}`, {headers:{Authorization:'Bearer '+(localStorage.getItem('calleb_token')||'')}})
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [casaId]);

  return (
    <div onClick={onClose} style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,.45)',
      display:'flex', alignItems:'center', justifyContent:'center',
      zIndex:1000, padding:16,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background:'#fff', borderRadius:16, padding:28,
        width:'100%', maxWidth:580, maxHeight:'85vh',
        overflowY:'auto', boxShadow:'0 20px 60px rgba(0,0,0,.25)',
      }}>
        {loading ? (
          <p style={{ color:'#9ca3af', textAlign:'center', padding:40 }}>Cargando…</p>
        ) : !data?.casa ? (
          <p style={{ color:'#dc2626' }}>No se pudo cargar el detalle.</p>
        ) : (
          <>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <div>
                <h3 style={{ fontSize:18, fontWeight:700, color:'#1a3a5c', margin:0 }}>
                  {data.casa.nombre_quinta}
                </h3>
                <p style={{ fontSize:12, color:'#6b7280', margin:'4px 0 0' }}>
                  {data.casa.propietario} · {data.casa.zona}
                </p>
              </div>
              <span style={badgeEstatus(data.casa.estatus)}>{data.casa.estatus}</span>
            </div>

            {/* Info contacto */}
            <div style={{ background:'#f8fafc', borderRadius:8, padding:12,
                          marginBottom:16, fontSize:12, color:'#374151' }}>
              📧 {data.casa.email || '—'} &nbsp;·&nbsp; 📞 {data.casa.telefono || '—'}
            </div>

            {/* Saldo */}
            <div style={{ display:'flex', gap:12, marginBottom:20 }}>
              {[
                { label:'Total Cargado',  val: data.casa.total_cargado,  color:'#dc2626' },
                { label:'Total Pagado',   val: data.casa.total_pagado,   color:'#15803d' },
                { label:'Saldo Pendiente',val: data.casa.saldo_pendiente,
                  color: parseFloat(data.casa.saldo_pendiente) > 0 ? '#dc2626' : '#15803d' },
              ].map(k => (
                <div key={k.label} style={{ flex:1, background:'#fff', border:'1px solid #e5e7eb',
                                             borderRadius:8, padding:'10px 14px', textAlign:'center' }}>
                  <div style={{ fontSize:10, color:'#9ca3af', marginBottom:4 }}>{k.label}</div>
                  <div style={{ fontSize:16, fontWeight:700, color:k.color }}>
                    {formatMoneda(k.val)}
                  </div>
                </div>
              ))}
            </div>

            {/* Cargos */}
            {data.cargos?.length > 0 && (
              <>
                <h4 style={{ fontSize:13, fontWeight:600, color:'#374151', marginBottom:8 }}>
                  Cargos ({data.cargos.length})
                </h4>
                <table style={{ width:'100%', borderCollapse:'collapse',
                                fontSize:12, marginBottom:16 }}>
                  <thead>
                    <tr style={{ background:'#f8fafc' }}>
                      {['Fecha','Tipo','Descripción','Monto','Pagado','Saldo'].map(h => (
                        <th key={h} style={{ padding:'6px 8px', textAlign:'left',
                                             color:'#6b7280', fontWeight:600,
                                             borderBottom:'1px solid #e5e7eb' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.cargos.map(c => {
                      const saldo = parseFloat(c.monto) - parseFloat(c.pagado || 0);
                      return (
                        <tr key={c.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                          <td style={{ padding:'6px 8px' }}>{formatFecha(c.fecha_cargo)}</td>
                          <td style={{ padding:'6px 8px' }}>
                            <span style={{ background:'#eff6ff', color:'#1d4ed8',
                                           padding:'1px 6px', borderRadius:8, fontSize:10 }}>
                              {c.tipo}
                            </span>
                          </td>
                          <td style={{ padding:'6px 8px', color:'#374151' }}>{c.descripcion}</td>
                          <td style={{ padding:'6px 8px', fontWeight:600 }}>{formatMoneda(c.monto)}</td>
                          <td style={{ padding:'6px 8px', color:'#15803d' }}>{formatMoneda(c.pagado)}</td>
                          <td style={{ padding:'6px 8px', fontWeight:700,
                                       color: saldo > 0 ? '#dc2626' : '#15803d' }}>
                            {formatMoneda(saldo)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            )}

            {/* Pagos */}
            {data.pagos?.length > 0 && (
              <>
                <h4 style={{ fontSize:13, fontWeight:600, color:'#374151', marginBottom:8 }}>
                  Pagos ({data.pagos.length})
                </h4>
                <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                  <thead>
                    <tr style={{ background:'#f8fafc' }}>
                      {['Fecha','Recibo','Método','Monto'].map(h => (
                        <th key={h} style={{ padding:'6px 8px', textAlign:'left',
                                             color:'#6b7280', fontWeight:600,
                                             borderBottom:'1px solid #e5e7eb' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.pagos.map(p => (
                      <tr key={p.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                        <td style={{ padding:'6px 8px' }}>{formatFecha(p.fecha_pago)}</td>
                        <td style={{ padding:'6px 8px', color:'#6b7280', fontSize:11 }}>
                          {p.numero_recibo}
                        </td>
                        <td style={{ padding:'6px 8px' }}>{p.metodo}</td>
                        <td style={{ padding:'6px 8px', fontWeight:700, color:'#15803d' }}>
                          {formatMoneda(p.monto)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

            <button onClick={onClose} style={{
              marginTop:20, width:'100%', padding:'10px',
              background:'#f3f4f6', border:'none', borderRadius:8,
              fontSize:13, cursor:'pointer', color:'#374151',
            }}>
              Cerrar
            </button>
          </>
        )}
      </div>
    </div>
  );
}

// ── Fila de casa ──────────────────────────────────────────
function FilaCasa({ casa, onPagar, onVerDetalle }) {
  const saldo = parseFloat(casa.saldo_pendiente) || 0;
  return (
    <tr style={{ borderBottom:'1px solid #f3f4f6' }}>
      <td style={td}>
        <div style={{ fontWeight:600, color:'#1a3a5c' }}>{casa.nombre_quinta}</div>
        <div style={{ fontSize:11, color:'#9ca3af' }}>{casa.identificador}</div>
      </td>
      <td style={td}>
        <div style={{ fontSize:13 }}>{casa.propietario}</div>
        <div style={{ fontSize:11, color:'#6b7280' }}>{casa.email}</div>
      </td>
      <td style={td}>{casa.telefono || '—'}</td>
      <td style={td}>
        <span style={{ background:'#eff6ff', color:'#1d4ed8',
                       padding:'2px 8px', borderRadius:12, fontSize:11 }}>
          {casa.zona}
        </span>
      </td>
      <td style={td}>
        <span style={badgeEstatus(casa.estatus)}>{casa.estatus}</span>
      </td>
      <td style={{ ...td, fontWeight:700,
                   color: saldo > 0 ? '#dc2626' : '#15803d' }}>
        {formatMoneda(saldo)}
      </td>
      <td style={{ ...td, color:'#6b7280', fontSize:12 }}>
        {formatFecha(casa.ultimo_pago)}
      </td>
      <td style={td}>
        <div style={{ display:'flex', gap:6 }}>
          <button onClick={() => onVerDetalle(casa.casa_id)}
                  style={btnSec} title="Ver detalle">👁 Ver</button>
          {saldo > 0 && (
            <button onClick={() => onPagar(casa)}
                    style={btnPrim} title="Registrar pago">
              💳 Pagar
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}

const td      = { padding:'10px 12px', verticalAlign:'middle', fontSize:13 };
const btnPrim = { background:'#1a3a5c', color:'#fff', border:'none',
                  borderRadius:6, padding:'5px 10px', fontSize:11, cursor:'pointer', fontWeight:600 };
const btnSec  = { background:'#f3f4f6', color:'#374151', border:'none',
                  borderRadius:6, padding:'5px 8px', fontSize:11, cursor:'pointer' };

// ── TABLA PRINCIPAL ───────────────────────────────────────
export default function TablaCasas() {
  const [casas,      setCasas]      = useState([]);
  const [resumen,    setResumen]    = useState(null);
  const [total,      setTotal]      = useState(0);
  const [pagina,     setPagina]     = useState(1);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState(null);
  const [casaPago,   setCasaPago]   = useState(null);
  const [detalleId,  setDetalleId]  = useState(null);
  const [busqueda,   setBusqueda]   = useState('');
  const [zona,       setZona]       = useState('');
  const [estatus,    setEstatus]    = useState('');
  const [zonas,      setZonas]      = useState([]);

  const debounceRef = useRef(null);
  const LIMITE = 30;

  const cargar = useCallback(async (p = 1, bus = busqueda, zon = zona, est = estatus) => {
    setLoading(true);
    setError(null);
    try {
      const data = await casasApi.listar({ busqueda: bus, zona: zon, estatus: est, pagina: p, limite: LIMITE });
      setCasas(data.casas || []);
      setTotal(data.total || 0);
      setResumen(data.resumen);
      setPagina(p);
      if (data.casas?.length && !zonas.length) {
        setZonas([...new Set(data.casas.map(c => c.zona))].sort());
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line
  }, []);

  // Carga inicial automática al montar
  useEffect(() => { cargar(1, '', '', ''); }, [cargar]);

  // Filtros con debounce
  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => cargar(1, busqueda, zona, estatus), 400);
    return () => clearTimeout(debounceRef.current);
  // eslint-disable-next-line
  }, [busqueda, zona, estatus]);

  const totalPaginas = Math.ceil(total / LIMITE);

  return (
    <div style={{ padding:24 }}>
      {/* Cabecera */}
      <div style={{ marginBottom:20, display:'flex', justifyContent:'space-between',
                    alignItems:'flex-start', flexWrap:'wrap', gap:12 }}>
        <div>
          <h2 style={{ fontSize:20, fontWeight:700, color:'#1a3a5c', margin:0 }}>
            Control de Casas
          </h2>
          {resumen && (
            <p style={{ fontSize:12, color:'#6b7280', margin:'4px 0 0' }}>
              {resumen.total_casas} casas ·&nbsp;
              <span style={{ color:'#15803d' }}>{resumen.solventes} solventes</span> ·&nbsp;
              <span style={{ color:'#dc2626' }}>{resumen.morosos} morosas</span> ·&nbsp;
              Deuda total: <strong>{formatMoneda(resumen.deuda_total)}</strong>
            </p>
          )}
        </div>
        <button onClick={() => cargar(1, busqueda, zona, estatus)}
                style={{ ...btnSec, padding:'8px 14px', fontSize:12 }}>
          🔄 Actualizar
        </button>
      </div>

      {/* Filtros */}
      <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginBottom:16 }}>
        <input type="text" placeholder="🔍 Buscar quinta, propietario…"
               value={busqueda} onChange={e => setBusqueda(e.target.value)}
               style={inputStyle}/>
        <select value={zona} onChange={e => setZona(e.target.value)} style={inputStyle}>
          <option value="">Todas las zonas</option>
          {zonas.map(z => <option key={z} value={z}>{z}</option>)}
        </select>
        <select value={estatus} onChange={e => setEstatus(e.target.value)} style={inputStyle}>
          <option value="">Todos los estados</option>
          <option value="SOLVENTE">Solvente</option>
          <option value="MOROSO">Moroso</option>
        </select>
        {(busqueda || zona || estatus) && (
          <button onClick={() => { setBusqueda(''); setZona(''); setEstatus(''); }}
                  style={{ ...btnSec, padding:'8px 14px' }}>✕ Limpiar</button>
        )}
      </div>

      {error && (
        <div style={{ padding:12, background:'#fef2f2', color:'#dc2626',
                      borderRadius:8, marginBottom:16, fontSize:13 }}>
          ⚠️ {error}
        </div>
      )}

      {/* Tabla */}
      <div style={{ overflowX:'auto', borderRadius:12,
                    boxShadow:'0 1px 4px rgba(0,0,0,.08)', background:'#fff' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:800 }}>
          <thead>
            <tr style={{ background:'#f8fafc' }}>
              {['Quinta / ID','Propietario','Teléfono','Zona',
                'Estatus','Saldo Pendiente','Último Pago','Acciones'].map(h => (
                <th key={h} style={{ padding:'10px 12px', textAlign:'left',
                                     fontSize:11, fontWeight:600, color:'#6b7280',
                                     borderBottom:'2px solid #e5e7eb', whiteSpace:'nowrap' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>
                Cargando casas…
              </td></tr>
            ) : casas.length === 0 ? (
              <tr><td colSpan={8} style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>
                No se encontraron casas.
              </td></tr>
            ) : (
              casas.map(casa => (
                <FilaCasa key={casa.casa_id} casa={casa}
                          onPagar={setCasaPago}
                          onVerDetalle={setDetalleId}/>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      {totalPaginas > 1 && (
        <div style={{ display:'flex', justifyContent:'center',
                      gap:8, marginTop:20, alignItems:'center' }}>
          <button onClick={() => cargar(pagina-1, busqueda, zona, estatus)}
                  disabled={pagina===1}
                  style={{ ...btnSec, opacity:pagina===1?.4:1 }}>← Anterior</button>
          <span style={{ fontSize:12, color:'#6b7280' }}>
            Página {pagina} de {totalPaginas} · {total} casas
          </span>
          <button onClick={() => cargar(pagina+1, busqueda, zona, estatus)}
                  disabled={pagina===totalPaginas}
                  style={{ ...btnSec, opacity:pagina===totalPaginas?.4:1 }}>Siguiente →</button>
        </div>
      )}

      {/* Modales */}
      {casaPago && (
        <ModalPago casa={casaPago} onClose={() => setCasaPago(null)}
                   onExito={() => { setCasaPago(null); cargar(pagina, busqueda, zona, estatus); }}/>
      )}
      {detalleId && (
        <ModalDetalle casaId={detalleId} onClose={() => setDetalleId(null)}/>
      )}
    </div>
  );
}

const inputStyle = {
  padding:'8px 12px', borderRadius:8, border:'1px solid #d1d5db',
  fontSize:13, background:'#fff', color:'#374151',
};
